var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 26,
    height: 26,
    transform: "rotate(-180 26 26)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_147_35926",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_147_35926",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACT0lEQVR4nO3aMW4TQRSH8W8jCxfryvERtnPLJUBCAglaOAMSEhIVNHTkDKQGiQLJnCKlu1wAkU2VLQDFQ7GEYMWBxjNv3sz/K12Mnn4arXdHA0oppZRSSimllFLl1FgPsM9WXTedzedvAzwFDgIczy4vX949OflpPdvEeoB9teq6aXt4+CmEcO/qtwaeD5PJBnhhOBoAB9YD7KMrZP5C/lMIzwxGupH7Hb1eLu+cte2Hnchji6QD3ZLrHf0b+SPwwHqW/+UW2hMyOIX2hgwOoT0igzNor8jgCNozMjiB9o4MDqBLQIbMoUtBhoyhS0KGTKFLQ4YMoUtEhsygS0WGjKBLRoZMoEtHhgyga0AGY+hakMEQuiZkMIKuDRkMoGtEhsTQtSJDQuiakSERdO3IkABayGNRoYV8XTRoIW8X5UrYquumZ7PZ7rtwlRZlR7fz+Rshbxfr0ZHFDc6cMj+9q6U40E3zPsq6josCPfT9a5rmS4y1vRYF+v7p6ffFxcVD4HOM9T0W7Rm9XK9/LIbhMcIGIv8ZCvu66G8dwh5L8non7ITv0bVjJ/1gqRk7+Zdhrdgmn+A1YpudddSGbXqoVBO2+eldLdjm0FAHdhbQUD52NtBQNnZW0FAudnbQUCZ2ltBQHna20FAWdtbQUA529tBQBrYLaPCP7QYafGO7gga/2O6gwSe2S2jwh+0WGnxhu4aGEXs4P3/yj7t+35IOdEvuoWG86zf0/aOd2CEcG4x0oyKgYQv7HfAV6Bs4ajebV9azKaWUUkoppZRSSpXWL7z6N/xWXwtiAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowRed);
export default __webpack_public_path__ + "static/media/left_arrow_red.cd59aac586e480e783250cf0bdc716da.svg";
export { ForwardRef as ReactComponent };